import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const ErrorContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: "40px 0",
}));

export const ErrorIconContainer = styled(Box)(({ theme }) => ({
  marginBottom: "24px",
  color: theme.palette.status?.error || "#EF5350",
}));

export const ErrorTitle = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: 600,
  color: theme.palette.text?.primary || "#1E293B",
  marginBottom: "16px",
}));

export const ErrorSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: theme.palette.text?.secondary || "#64748B",
  marginBottom: "32px",
  lineHeight: "24px",
}));

export const ErrorActions = styled(Box)(() => ({
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  width: "100%",
  maxWidth: "300px",

  "& button": {
    height: "48px",
    fontSize: "16px",
    fontWeight: 600,
  },
}));
